webpackJsonp([1],{

/***/ "/9jR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _modal = __webpack_require__("MPO3");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "addNewProject",
    props: ['content', 'project'],
    components: {
        'app-modal': _modal2.default
    },
    created: function created() {
        this.project != null ? this.getProject() : this.show = true;
    },
    data: function data() {
        return {
            btn: 'Añadir',
            proyecto: {
                proyecto: ''
            },
            showBottons: false,
            show: false
        };
    },

    methods: {
        closeModal: function closeModal() {
            this.$root.$emit('closeModal');
        },
        getProject: function getProject() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'SELECT',
                                    fields: ['id', 'proyecto'],
                                    where: ' id = ' + _this.project,
                                    table: 'proyectos'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this.proyecto = response.data;
                                        setTimeout(function () {
                                            _this.show = true;
                                        }, 100);
                                    }
                                });

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        saveProject: function saveProject() {
            this.project != null ? this.update() : this.insert();
        },
        insert: function insert() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'INSERT',
                                    table: 'proyectos',
                                    form: _this2.proyecto
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado' && response.data != "El usuario ya existe") {
                                        _this2.$root.$emit('msgSuccess', 'Registro insertado');
                                        setTimeout(function () {
                                            _this2.$root.$emit('closeModal');
                                        }, 2000);
                                    } else {
                                        _this2.$root.$emit('msgError', response.data);
                                    }
                                });

                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        update: function update() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var form;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                form = { proyecto: _this3.proyecto.proyecto };

                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'UPDATE',
                                    table: 'proyectos',
                                    form: form,
                                    id: _this3.project
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado' && response.data != "El usuario ya existe") {
                                        _this3.$root.$emit('msgSuccess', 'Registro insertado');
                                        setTimeout(function () {
                                            _this3.$root.$emit('closeModal');
                                        }, 2000);
                                    } else {
                                        _this3.$root.$emit('msgError', response.data);
                                    }
                                });

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "04Xd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _sha = __webpack_require__("uXeI");

var _sha2 = _interopRequireDefault(_sha);

var _vuex = __webpack_require__("NYxO");

var _actions = __webpack_require__("lHQJ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Login",
    data: function data() {
        return {
            form: {
                user: null,
                pass: null
            },
            formLogin: true,
            btn: "Entrar"
        };
    },
    created: function created() {
        this.checkCurrentLogin();
    },
    updated: function updated() {
        this.checkCurrentLogin();
    },

    methods: {
        checkCurrentLogin: function checkCurrentLogin() {
            if (this.currentUser) {
                this.$router.replace(this.$route.query.redirect || "/login");
            }
        },
        submitForm: function submitForm() {
            this.formLogin ? this.login() : this.recoveryPass();
        },
        recoveryPass: function recoveryPass() {
            var _this = this;

            this.$store.dispatch(_actions.RECOVERY_PASS, { user: this.form.user }).then(function (response) {
                if (response.data.error == true) {
                    _this.msgError(response.data.response);
                } else {
                    _this.msgSuccess(response.data.response);
                }
            }).catch(function (error) {
                return _this.msgError(error.response);
            });
        },
        login: function login() {
            var _this2 = this;

            this.$store.dispatch(_actions.LOGIN, { user: this.form.user, pass: (0, _sha2.default)(this.form.pass) }).then(function (response) {
                return _this2.loginSuccessful(response);
            }).catch(function (error) {
                return _this2.loginFailed(error);
            });
        },
        loginSuccessful: function loginSuccessful(response) {
            if (!response.token) {
                this.loginFailed(response);
                return;
            }
            this.$notify({
                title: 'Success',
                message: 'Login correcto',
                type: 'success',
                position: 'bottom-right'
            });
            this.error = false;
            localStorage.analiticatoken = response.token;

            this.$router.replace(this.$route.query.redirect || { name: "proyectos" });
        },
        loginFailed: function loginFailed(request) {
            this.$notify.error({
                title: 'Error',
                message: 'Usuario o contraseña incorrecta',
                position: 'bottom-right'
            });
            this.$store.dispatch("logout");
            delete localStorage.analiticatoken;
        },
        remenberPass: function remenberPass() {
            this.btn = "Recuperar contraseña";
            this.formLogin = false;
        },
        returnLogin: function returnLogin() {
            this.formLogin = !this.formLogin;
            this.btn = 'Entrar';
        },
        msgSuccess: function msgSuccess(text) {
            this.$notify({
                title: 'Success',
                message: text,
                type: 'success',
                position: 'top-right'
            });
        },
        msgError: function msgError(text) {
            this.$notify.error({
                title: 'Error',
                message: text,
                position: 'top-right'
            });
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({ currentUser: "currentUser" }), (0, _vuex.mapState)({ errors: function errors(state) {
            return state.auth.errors;
        } }))
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "0LC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('app-table-paginate',{attrs:{"routeEdit":_vm.routeEdit,"routeDelete":_vm.routeDelete,"routeView":_vm.routeView,"tableQuery":_vm.tableData,"tableColumns":_vm.headers,"sidebar":true,"items":40,"multipleSelect":(_vm.isAdmin ? true : false),"draggable":(_vm.isAdmin ? true : false),"customclass":'table--white',"search":true}}),_vm._v(" "),(_vm.modalDraggable)?_c('app-modal-draggable',{attrs:{"content":_vm.tableData,"name":'nombre',"table":'informes'}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0tZ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _actions = __webpack_require__("lHQJ");

var _Sidebar = __webpack_require__("FP+P");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _TopNavbar = __webpack_require__("vUI4");

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _ContentFooter = __webpack_require__("pZZj");

var _ContentFooter2 = _interopRequireDefault(_ContentFooter);

var _Content = __webpack_require__("ZcUT");

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'Dashboard',
	created: function created() {
		var _this = this;

		this.user();
		this.$root.$on('msgSuccess', function (text) {
			_this.msgSuccess(text);
		});
		this.$root.$on('msgError', function (text) {
			_this.msgError(text);
		});
		this.$root.$on('isConnect', function () {
			_this.isConnect();
		});
	},

	components: {
		'app-sidebar': _Sidebar2.default,
		'app-navbar': _TopNavbar2.default,
		'app-content': _Content2.default,
		'app-footer': _ContentFooter2.default
	},
	methods: {
		user: function user() {
			var obj = JSON.parse(localStorage.getItem('analiticauser'));
			this.$store.dispatch(_actions.FECTH_AUTH, obj);
		},
		msgSuccess: function msgSuccess(text) {
			this.$notify({
				title: 'Success',
				message: text,
				type: 'success',
				position: 'top-right'
			});
		},
		msgError: function msgError(text) {
			this.$notify.error({
				title: 'Error',
				message: text,
				position: 'top-right'
			});
		},
		isConnect: function isConnect() {
			var _this2 = this;

			console.log('aa');
			if (!localStorage.getItem('analiticatoken')) {
				this.msgError('Su sesión ha caducado.');
				setTimeout(function () {
					_this2.$router.go('/login');
				}, 1000);
				return false;
			}
			return true;
		}
	}
}; //
//
//
//
//
//
//
//
//

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1tpP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__("NYxO");

var _actions = __webpack_require__("lHQJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            googleSignInParams: {
                client_id: "79541948737-cofvlcg5coukbvb0hmnet59plai1ogas.apps.googleusercontent.com"
            }
        };
    },

    methods: {
        onSignInSuccess: function onSignInSuccess(googleUser) {
            var _this = this;

            var profile = googleUser.getBasicProfile();
            console.log(googleUser);
            console.log(profile);
            var email = profile.getEmail();
            this.$store.dispatch(_actions.LOGIN_GOOGLE, { user: email }).then(function (response) {
                return _this.loginSuccessful(response);
            }).catch(function (error) {
                return _this.loginFailed(error);
            });
        },
        onSignInError: function onSignInError(error) {
            console.log(error);

            this.loginSuccessful(error);
        },
        loginSuccessful: function loginSuccessful(response) {
            console.log(response);
            if (!response.token) {
                this.loginFailed(response);
                return;
            }
            this.$notify({
                title: "Success",
                message: "Login correcto",
                type: "success",
                position: "bottom-right"
            });
            this.error = false;
            localStorage.analiticatoken = response.token;
            this.$router.replace(this.$route.query.redirect || { name: "proyectos" });
        },
        loginFailed: function loginFailed(request) {
            this.$notify.error({
                title: "Error",
                message: "Usuario o contraseña incorrecta",
                position: "bottom-right"
            });
            this.$store.dispatch("logout");
            delete localStorage.analiticatoken;
        }
    }
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2UrO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations, _actions; /* global localStorage */


var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _actions2 = __webpack_require__("lHQJ");

var _mutations2 = __webpack_require__("AezD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    errors: null,
    db_tables: null
};

var getters = {
    getDbTables: function getDbTables(state) {
        return state.db_tables;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutations2.SET_ERROR, function (state, error) {
    state.errors = error;
}), (0, _defineProperty3.default)(_mutations, _mutations2.SET_DB_TABLES, function (state, db_tables) {
    state.db_tables = db_tables;
    state.errors = {};
}), _mutations);

var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, _actions2.FECTH_DB_TABLES, function (context, data) {
    if (this.db_tables) {
        return this.getDbTables();
    }
    return new _promise2.default(function (resolve) {
        _api2.default.post('dashboard/show_db_table', data).then(function (data) {
            context.commit(_mutations2.SET_DB_TABLES, data.data);
            resolve(data.data);
        }).catch(function (data) {
            context.commit(_mutations2.SET_ERROR, data);
        });
    });
}), (0, _defineProperty3.default)(_actions, _actions2.FECTH_CHECK_BUILDER, function (context, data) {
    return new _promise2.default(function (resolve) {
        _api2.default.post('dashboard/checkBuilder', data).then(function (data) {
            resolve(data.data);
        }).catch(function (data) {
            context.commit(_mutations2.SET_ERROR, data);
        });
    });
}), _actions);

exports.default = {
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
};

/***/ }),

/***/ "2rFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3wrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',[_c('el-card',{staticClass:"box-card"},[_c('h2',[_vm._v("Arrastra los items arriba / abajo para ordenar")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('draggable',{model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},[_c('transition-group',{attrs:{"name":"list-complete"}},_vm._l((_vm.items),function(element){return (element.id != 0)?_c('div',{key:element.id,staticClass:"item"},[_vm._v(" "+_vm._s(element[_vm.name])+" "),_c('hr')]):_vm._e()}),0)],1),_vm._v(" "),_c('el-button',{on:{"click":_vm.update}},[_vm._v("Guardar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "5MmI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jwtSimple = __webpack_require__("Adj7");

var _jwtSimple2 = _interopRequireDefault(_jwtSimple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ID_TOKEN_KEY = 'analiticatoken';
var SECRET_KEY = 'acr[aaa@3·';

exports.default = {
	getToken: function getToken() {
		return window.localStorage.getItem(ID_TOKEN_KEY);
	},
	getTokenApp: function getTokenApp() {
		return _jwtSimple2.default.encode(ID_TOKEN_KEY, SECRET_KEY, 'HS256');
	},
	setEncode: function setEncode(payload) {
		return _jwtSimple2.default.encode(payload, SECRET_KEY);
	},
	getDecode: function getDecode(token) {
		return _jwtSimple2.default.decode(token, SECRET_KEY);
	},
	saveToken: function saveToken(token) {
		window.localStorage.setItem(ID_TOKEN_KEY, token);
	},
	destroyToken: function destroyToken() {
		window.localStorage.removeItem(ID_TOKEN_KEY);
	}
};

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5YTu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _config = __webpack_require__("wYMm");

var _modal = __webpack_require__("MPO3");

var _modal2 = _interopRequireDefault(_modal);

var _vuedraggable = __webpack_require__("u4Bf");

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "modalDraggable",
    props: ['content', 'name', 'table'],
    components: {
        'app-modal': _modal2.default,
        draggable: _vuedraggable2.default
    },
    created: function created() {
        var _this = this;

        var order = this.order;
        this.items = [{
            id: 0,
            order: 0
        }];
        this.content.forEach(function (element) {
            _this.items.push(element);
        });
    },
    data: function data() {
        return {
            btn: 'Guardar',
            items: null,
            show: false,
            order: 'order_row'
        };
    },

    methods: {
        closeModal: function closeModal() {
            this.$root.$emit('closeModal');
        },
        update: function update() {
            var _this2 = this;

            this.items.forEach(function (element, index) {
                if (element.id != 0) {
                    _api2.default.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: true,
                        method: 'UPDATE',
                        id: element.id,
                        table: 'informes',
                        form: { order_row: index }
                    }).then(function (response) {
                        _this2.$root.$emit('msgSuccess', 'Registro insertado');
                    });
                }
            });
            setTimeout(function () {
                _this2.closeModal();
            }, 100);
        }
    }
};

/***/ }),

/***/ "6IQb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "modal",
    props: ['classContainer'],
    methods: {
        close: function close() {
            this.$root.$emit('closeModal');
        }
    }
};

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6qrf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations, _actions; /* global localStorage */


var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _actions2 = __webpack_require__("lHQJ");

var _mutations2 = __webpack_require__("AezD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    showSidebar: true,
    sidebar: 'informes'
};

var getters = {
    getSidebar: function getSidebar(state) {
        return state.sidebar;
    },
    getShowSidebar: function getShowSidebar(state) {
        return state.showSidebar;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutations2.SET_SIDEBAR, function (state, sidebar) {
    state.sidebar = sidebar;
    state.errors = {};
}), (0, _defineProperty3.default)(_mutations, _mutations2.SET_SHOW_SIDEBAR, function (state, sidebar) {
    state.showSidebar = showSidebar;
    state.errors = {};
}), _mutations);

var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, _actions2.FECTH_SIDEBAR, function (context, data) {
    context.commit(_mutations2.SET_SIDEBAR, data);
}), (0, _defineProperty3.default)(_actions, _actions2.FECTH_SHOW_SIDEBAR, function (context, data) {
    context.commit(_mutations2.SET_SIDEBAR, data);
}), _actions);

exports.default = {
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
};

/***/ }),

/***/ "75W6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__ = __webpack_require__("mtlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27bebc5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__ = __webpack_require__("hLYk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27bebc5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "AD02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("Mis Informes")])],1),_vm._v(" "),(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('el-row',[_c('el-col',{attrs:{"span":7}},[_c('app-table-paginate',{attrs:{"routeEdit":false,"routeDelete":false,"routeView":false,"routeSelect":true,"tableQuery":_vm.tableData,"tableColumns":_vm.headers,"multipleSelect":false}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('p',{staticClass:"invisible"},[_vm._v("a")])]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[(_vm.viewReports)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('app-informes',{attrs:{"project":_vm.viewReports}})],1):_vm._e()],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AezD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_AUTH = exports.SET_AUTH = 'setUser';
var SET_LOCALSTORE = exports.SET_LOCALSTORE = 'seTLocalstore';

var PURGE_AUTH = exports.PURGE_AUTH = 'logOut';
var SET_ERROR = exports.SET_ERROR = 'setError';

var SET_DB_TABLES = exports.SET_DB_TABLES = 'setDbTables';
var SET_DB_TABLE = exports.SET_DB_TABLE = 'setDbTable';

var SET_SIDEBAR = exports.SET_SIDEBAR = 'SET_SIDEBAR';
var SET_SHOW_SIDEBAR = exports.SET_SHOW_SIDEBAR = 'SET_SHOW_SIDEBAR';

/***/ }),

/***/ "BED7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue__ = __webpack_require__("gMEm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028a0c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_misinformes_vue__ = __webpack_require__("AD02");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_misinformes_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028a0c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_misinformes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CQP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue__ = __webpack_require__("xaox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f118e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proyectos_vue__ = __webpack_require__("hCAS");
function injectStyle (ssrContext) {
  __webpack_require__("Z8KC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proyectos_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f118e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proyectos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D+VX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations, _actions; /* global localStorage */


var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _jwt = __webpack_require__("5MmI");

var _jwt2 = _interopRequireDefault(_jwt);

var _User = __webpack_require__("gRp0");

var _User2 = _interopRequireDefault(_User);

var _actions2 = __webpack_require__("lHQJ");

var _mutations2 = __webpack_require__("AezD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    errors: null,
    user: null,
    isAuthenticated: !!_jwt2.default.getToken()
};

var getters = {
    currentUser: function currentUser(state) {
        return state.user;
    },
    isAuthenticated: function isAuthenticated(state) {
        return state.isAuthenticated;
    },
    isAdmin: function isAdmin(state) {
        return state.user.admin;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutations2.SET_ERROR, function (state, error) {
    state.errors = error;
}), (0, _defineProperty3.default)(_mutations, _mutations2.SET_LOCALSTORE, function (state, user) {

    state.isAuthenticated = true;
    state.user = _User2.default.from(user);
    state.errors = {};
    _jwt2.default.saveToken(state.user.token);

    localStorage.setItem('analiticauser', (0, _stringify2.default)(state.user));
    localStorage.setItem('analiticatoken', user);

    if (state.user.rol === '1' || state.user.rol === '3') {
        state.user.admin = true;
    }
}), (0, _defineProperty3.default)(_mutations, _mutations2.SET_AUTH, function (state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};

    if (state.user.rol === '1' || state.user.rol === '3') {
        state.user.admin = true;
    }
}), (0, _defineProperty3.default)(_mutations, _mutations2.PURGE_AUTH, function (state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    _jwt2.default.destroyToken();
    localStorage.removeItem('analiticauser');
    localStorage.removeItem('analiticatoken');
}), _mutations);

var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, _actions2.RECOVERY_PASS, function (context, email) {
    return _api2.default.post('recoverypass', email);
}), (0, _defineProperty3.default)(_actions, _actions2.LOGIN, function (context, credentials) {
    return new _promise2.default(function (resolve) {
        _api2.default.post('auth', credentials).then(function (_ref) {
            var data = _ref.data;

            context.commit(_mutations2.SET_LOCALSTORE, data.token);
            resolve(data);
        }).catch(function (_ref2) {
            var response = _ref2.response;

            context.commit(_mutations2.SET_ERROR, response.data.response);
            resolve(response.data.response);
        });
    });
}), (0, _defineProperty3.default)(_actions, _actions2.LOGIN_GOOGLE, function (context, credentials) {
    return new _promise2.default(function (resolve) {
        _api2.default.post('auth_google', credentials).then(function (_ref3) {
            var data = _ref3.data;

            context.commit(_mutations2.SET_LOCALSTORE, data.token);
            resolve(data);
        }).catch(function (_ref4) {
            var response = _ref4.response;

            context.commit(_mutations2.SET_ERROR, response.data.response);
            resolve(response.data.response);
        });
    });
}), (0, _defineProperty3.default)(_actions, _actions2.FECTH_AUTH, function (context, data) {
    context.commit(_mutations2.SET_AUTH, data);
}), (0, _defineProperty3.default)(_actions, _actions2.LOGOUT, function (context) {
    context.commit(_mutations2.PURGE_AUTH);
}), (0, _defineProperty3.default)(_actions, _actions2.CHECK_AUTH, function (context) {
    if (_jwt2.default.getToken()) {
        _api2.default.setHeader();
        // ApiService
        //   .get('user')
        //   .then(({data}) => {
        //     context.commit(SET_AUTH, data.user)
        //   })
        //   .catch(({response}) => {
        //     context.commit(SET_ERROR, response.data.errors)
        //   })
    } else {
        context.commit(_mutations2.PURGE_AUTH);
    }
}), _actions);

exports.default = {
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
};

/***/ }),

/***/ "DM/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue__ = __webpack_require__("Qqbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c866e5a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformesProyecto_vue__ = __webpack_require__("0LC0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformesProyecto_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c866e5a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformesProyecto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EyqK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations; /* global localStorage */


var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _actions2 = __webpack_require__("lHQJ");

var _mutations2 = __webpack_require__("AezD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    dashboard: {},
    errors: null
};

var getters = {
    getDashboard: function getDashboard(state) {
        return state.dashboard;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutations2.SET_ERROR, function (state, error) {
    state.errors = error;
}), (0, _defineProperty3.default)(_mutations, _mutations2.SET_DASHBOARD, function (state, dashboard) {
    state.dashboard = dashboard;
    state.errors = {};
}), _mutations);

var actions = (0, _defineProperty3.default)({}, _actions2.FECTH_DASHBOARD, function (context, data) {
    if (this.sidebar) {
        return this.getSidebar();
    }
    return new _promise2.default(function (resolve) {
        _api2.default.post('dashboard/db', data).then(function (data) {
            context.commit(_mutations2.SET_DASHBOARD, data.data.response);
            resolve(data.data.response);
        }).catch(function (data) {
            context.commit(_mutations2.SET_ERROR, data);
        });
    });
});

exports.default = {
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
};

/***/ }),

/***/ "FOpv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue__ = __webpack_require__("ghFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee246fa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informes_vue__ = __webpack_require__("haaW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Informes_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee246fa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FP+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("jltm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8bf5d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("MSJf");
function injectStyle (ssrContext) {
  __webpack_require__("v0TN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d8bf5d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8bf5d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "G4uY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GhYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"classContainer":'height--xs o-hidden'}},[(_vm.show)?_c('el-card',{staticClass:"box-card"},[_c('el-form',{ref:"form",attrs:{"label-position":"top","id":"project"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.saveProject($event)}}},[_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"Proyecto"}},[_c('el-input',{model:{value:(_vm.proyecto.proyecto),callback:function ($$v) {_vm.$set(_vm.proyecto, "proyecto", $$v)},expression:"proyecto.proyecto"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[(_vm.proyecto.proyecto.length >= 3)?_c('button',{staticClass:"el-button el-button--primary",attrs:{"type":"submit"}},[_c('span',[_vm._v(_vm._s(_vm.btn))])]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Atrás")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H1JQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"frameborder":"0","id":"report"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HLUH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _auth = __webpack_require__("D+VX");

var _auth2 = _interopRequireDefault(_auth);

var _dashboard = __webpack_require__("EyqK");

var _dashboard2 = _interopRequireDefault(_dashboard);

var _db_tables = __webpack_require__("2UrO");

var _db_tables2 = _interopRequireDefault(_db_tables);

var _sidebar = __webpack_require__("6qrf");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    modules: {
        auth: _auth2.default,
        dashboard: _dashboard2.default,
        db_tables: _db_tables2.default,
        sidebar: _sidebar2.default
    }
});

/***/ }),

/***/ "J04Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_shasum":"05c5678d7173c049d8ca433552224a495d0e3762","_spec":"elliptic@^6.0.0","_where":"Z:\\htdocs\\grdar\\analitica\\web\\app_analitica_grdar-master\\node_modules\\browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}

/***/ }),

/***/ "Kswl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lg1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

exports.default = {
    name: 'Informe',
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser', 'isAdmin'])),
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            loading: true,
            url: false,
            width: null,
            height: null
        };
    },

    watch: {
        $route: function $route(to) {
            this.loading = true;
            this.init();
        }
    },
    methods: {
        init: function init() {
            this.getReport();
            this.customIframe();
        },
        getReport: function getReport() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.isAdmin) {
                                    _api2.default.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: true,
                                        method: 'SELECT',
                                        fields: ['informes.url', 'informes.width', 'informes.height'],
                                        inner: ['reports_projects, report_id, id, informes', 'users_projects, project_id, project_id, reports_projects'],
                                        where: ' informes.id = ' + _this.$route.params.informe_id,
                                        groupby: ' informes.id',
                                        table: 'informes'
                                    }).then(function (response) {
                                        if (response.data != 'Algo ha fallado') {
                                            if (!response.data) {
                                                _this.$router.push('/dashboard');
                                            }
                                            _this.url = response.data.url;
                                            _this.width = response.data.width;
                                            _this.height = response.data.height;
                                        }
                                        setTimeout(function () {
                                            _this.loading = false;
                                        }, 100);
                                    });
                                } else {
                                    _api2.default.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: true,
                                        method: 'SELECT',
                                        fields: ['informes.url', 'informes.width', 'informes.height'],
                                        inner: ['reports_projects, report_id, id, informes', 'users_projects, project_id, project_id, reports_projects'],
                                        where: ' users_projects.user_id = ' + _this.currentUser.id + ' AND informes.id = ' + _this.$route.params.informe_id,
                                        groupby: ' informes.id',
                                        table: 'informes'
                                    }).then(function (response) {
                                        if (response.data != 'Algo ha fallado') {
                                            if (!response.data) {
                                                _this.$router.push('/dashboard');
                                            }
                                            _this.url = response.data.url;
                                            _this.width = response.data.width;
                                            _this.height = response.data.height;
                                        }
                                        setTimeout(function () {
                                            _this.loading = false;
                                        }, 100);
                                    });
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
};

/***/ }),

/***/ "LguZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__("Rf8U");

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _jwt = __webpack_require__("5MmI");

var _jwt2 = _interopRequireDefault(_jwt);

var _config = __webpack_require__("wYMm");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiService = {
  init: function init() {
    _vue2.default.use(_vueAxios2.default, _axios2.default);
    _vue2.default.axios.defaults.baseURL = _config.API_URL;
  },
  setHeader: function setHeader() {
    _vue2.default.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    _vue2.default.http.headers.common['Access-Control-Allow-Origin'] = '*';
    _vue2.default.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin';
  },
  setHeaderAuth: function setHeaderAuth() {
    _vue2.default.axios.defaults.headers.common['Authorization'] = 'Token ' + _jwt2.default.getToken();
  },
  query: function query(resource, params) {
    return _vue2.default.axios.get(resource, params).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  },
  get: function get(resource) {
    var slug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return _vue2.default.axios.get(resource + '/' + slug).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  },
  post: function post(resource, params) {
    return _vue2.default.axios({
      method: "post",
      url: resource,
      data: params,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },
  update: function update(resource, slug, params) {
    return _vue2.default.axios.put(resource + '/' + slug, params);
  },
  put: function put(resource, params) {
    return _vue2.default.axios.put('' + resource, params);
  },
  delete: function _delete(resource) {
    return _vue2.default.axios.delete(resource).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  }
};

exports.default = ApiService;

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9833e014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("J04Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9833e014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MPO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("6IQb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd696a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("gGjE");
function injectStyle (ssrContext) {
  __webpack_require__("G4uY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd696a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MSJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{attrs:{"width":(_vm.isCollapse ? '64px' : '250px')}},[_c('el-menu',{staticClass:"el-menu-custom",attrs:{"default-active":_vm.activeIndex,"collapse":_vm.isCollapse,"background-color":"#f8f8f8","text-color":"#181C20","active-text-color":"#8f0ced"},on:{"select":_vm.handleSelect}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"#"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"/static/img/logo_gnet.png","alt":""}})])])]),_vm._v(" "),(_vm.isAdmin)?[(_vm.currentUser.rol == 1)?_c('el-menu-item',{attrs:{"index":"Usuarios","exact":""},on:{"click":function($event){return _vm.cambio('/dashboard/usuarios')}}},[_c('i',{staticClass:"ionicons ion-ios-people"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Gestión de usuarios")])]):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"Informes","exact":""},on:{"click":function($event){return _vm.cambio('/dashboard/proyectos')}}},[_c('i',{staticClass:"ionicons ion-ios-list-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Gestión de proyectos")])])]:_vm._e(),_vm._v(" "),(!_vm.isAdmin)?[_c('el-menu-item',{attrs:{"index":"Usuarios","exact":""},on:{"click":function($event){return _vm.cambio('/dashboard/misinformes')}}},[_c('i',{staticClass:"ionicons ion-ios-list-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Mis informes")])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.links),function(link,index){return (_vm.showSidebar)?_c('el-menu-item',{key:index,attrs:{"index":link.id,"exact":""},on:{"click":function($event){return _vm.cambio('/dashboard/informe/' + link.id)}}},[_c('i',{class:link.icono}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(link.nombre))])]):_vm._e()}),_vm._v(" "),_c('el-menu-item',{staticClass:"menu__custom-logout",attrs:{"index":"1"},on:{"click":_vm.desconectar}},[_c('i',{staticClass:"ionicons ion-ios-locked-outline"}),_vm._v(" "),_c('span',{staticClass:"item--custom"},[_vm._v(_vm._s(_vm.currentUser.name))]),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Logout")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vClickOutside = __webpack_require__("T+v0");

var _vClickOutside2 = _interopRequireDefault(_vClickOutside);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vueAuthenticate = __webpack_require__("WrNK");

var _vueAuthenticate2 = _interopRequireDefault(_vueAuthenticate);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__("lHQJ");

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _error = __webpack_require__("hgdF");

var _error2 = _interopRequireDefault(_error);

var _elementUi = __webpack_require__("zL8q");

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__("tvR6");

__webpack_require__("5W1q");

__webpack_require__("iTXB");

__webpack_require__("pgpf");

__webpack_require__("MU8w");

var _es = __webpack_require__("JR9b");

var _es2 = _interopRequireDefault(_es);

var _locale = __webpack_require__("urW8");

var _locale2 = _interopRequireDefault(_locale);

var _vueGoogleSigninButton = __webpack_require__("fSYm");

var _vueGoogleSigninButton2 = _interopRequireDefault(_vueGoogleSigninButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.use(_vueGoogleSigninButton2.default);

// configure language


// plugin setup


// Plugins - css + library imports
_locale2.default.use(_es2.default);

_vue2.default.config.productionTip = false;
_vue2.default.filter('error', _error2.default);

_vue2.default.use(_elementUi2.default);

_vue2.default.config.productionTip = false;

_api2.default.init();

_router2.default.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!_store2.default.state.auth.isAuthenticated) {
      next({
        path: '/Login',
        query: { replace: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
var vm = new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  GSignInButton: _vueGoogleSigninButton2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ "PhPj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QiRa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__("lHQJ");

exports.default = {
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    desconectar: function desconectar() {
      var _this = this;

      this.$store.dispatch(_actions.LOGOUT).then(function () {
        _this.$router.push('/login');
      });
    },
    toggle: function toggle() {
      this.$root.$emit("toogleChange", true);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Qqbj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _tablaConPaginador = __webpack_require__("SZZG");

var _tablaConPaginador2 = _interopRequireDefault(_tablaConPaginador);

var _vuex = __webpack_require__("NYxO");

var _draggable = __webpack_require__("mo8Y");

var _draggable2 = _interopRequireDefault(_draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Informes',
    props: ['project'],
    components: {
        'app-table-paginate': _tablaConPaginador2.default,
        'app-modal-draggable': _draggable2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin'])),
    created: function created() {
        var _this = this;

        this.$root.$on('sidebarUpdate', function (id, element, value) {
            _this.sidebarUpdate(id, value);
        });
        if (this.isAdmin) {
            this.routeView = 'informe/';
            this.routeEdit = '/dashboard/form/informe/';
            this.routeDelete = true;
        } else {
            this.routeView = 'informe/';
            this.routeEdit = false;
            this.routeDelete = false;
        }

        this.init();
        this.$root.$on('delete', function (id) {
            return _this.eliminarRegistro(id);
        });
        this.$root.$on('showmodaldraggable', function (e) {
            return _this.showDraggable();
        });
    },
    data: function data() {
        return {
            loading: true,
            headers: [{
                'prop': 'icono',
                'label': 'Icono'
            }, {
                'prop': 'nombre',
                'label': 'Nombre'
            }, {
                'prop': 'visible',
                'label': 'Menú'
            }],
            field: {},
            tableQuery: {},
            routeEdit: null,
            deleterow: false,
            modalDraggable: false
        };
    },

    watch: {
        $route: function $route(to) {
            this.loading = true;
            this.tableQuery = {};
            this.headers = [];
            this.routeEdit = '/dashboard/form/informe/';
            this.init();
        }
    },
    methods: {
        init: function init() {
            this.getTableData();
        },
        nuevoRegistro: function nuevoRegistro() {
            this.$router.push('/dashboard/form/informe/');
        },
        getTableData: function getTableData() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.project == '0') {
                                    _api2.default.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: false,
                                        method: 'select',
                                        table: 'informes',
                                        order: [' informes.order_row']
                                    }).then(function (response) {
                                        if (response.data == 'Algo ha fallado') {
                                            _this2.tableData = [];
                                        } else {
                                            var reports_projects = void 0;
                                            var reports = response.data;
                                            _api2.default.post("public/v1", {
                                                token: localStorage.getItem("analiticatoken"),
                                                single: false,
                                                method: 'select',
                                                fields: ['report_id'],
                                                table: 'reports_projects'
                                            }).then(function (response) {
                                                reports_projects = response.data.map(function (r) {
                                                    return r.report_id;
                                                });
                                                var a = reports.filter(function (r) {
                                                    if (!reports_projects.includes(r.id)) {
                                                        return r;
                                                    }
                                                });
                                                setTimeout(function () {
                                                    _this2.tableData = a.map(function (i) {
                                                        i.visible == 1 ? i.visible = 'Sí' : i.visible = 'No';
                                                        return i;
                                                    });
                                                }, 500);
                                            });
                                        }
                                        setTimeout(function () {
                                            _this2.loading = false;
                                        }, 1000);
                                    });
                                } else {
                                    _api2.default.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: false,
                                        method: 'select',
                                        fields: ['informes.id', 'informes.icono', 'informes.url', 'informes.nombre', 'informes.descripcion', 'informes.visible', 'informes.order_row'],
                                        inner: ['reports_projects, report_id, id, informes'],
                                        where: ' reports_projects.project_id = ' + _this2.project,
                                        table: 'informes',
                                        order: [' informes.order_row']
                                    }).then(function (response) {
                                        if (response.data == 'Algo ha fallado') {
                                            _this2.tableData = [];
                                        } else {
                                            _this2.tableData = response.data.map(function (i) {
                                                i.visible == 1 ? i.visible = 'Sí' : i.visible = 'No';
                                                return i;
                                            });
                                        }
                                        setTimeout(function () {
                                            _this2.loading = false;
                                        }, 100);
                                    });
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        eliminarRegistro: function eliminarRegistro(id) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.loading = true;
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    method: 'DELETE',
                                    id: id,
                                    table: 'informes'
                                }).then(function (response) {
                                    if (response.data == 1) {
                                        _this3.$root.$emit('msgSuccess', 'Registro ELIMINADO');
                                        setTimeout(function () {
                                            _this3.init();
                                        }, 1000);
                                    } else {
                                        // this.$root.$emit('msgError', 'Algo ha fallado')
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        sidebarUpdate: function sidebarUpdate(id, value) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var form;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                form = {
                                    visible: value
                                };

                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'UPDATE',
                                    id: id,
                                    table: 'informes',
                                    form: form
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado' && response.data != "El usuario ya existe") {
                                        _this4.$root.$emit('msgSuccess', 'Registro actualizado');
                                        _this4.loading = true;
                                        _this4.init();
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        showDraggable: function showDraggable() {
            this.modalDraggable = true;
        },
        closeModal: function closeModal() {
            this.$root.$emit('isConnect');
            this.modalDraggable = false;
            this.init();
        }
    }
};

/***/ }),

/***/ "R/jh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R1qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__ = __webpack_require__("xJ/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edbeb3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_vue__ = __webpack_require__("ipBY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edbeb3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RhbP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _config = __webpack_require__("wYMm");

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'tablaConPaginador',
    props: ['routeEdit', 'tableQuery', 'tableColumns', 'routeDelete', 'routeView', 'routeSelect', 'items', 'sidebar', 'multipleSelect', 'draggable', 'customclass', 'search' // Activa el buscador
    ],
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            currentPage: 1,
            totalRegistros: null,
            itemsPorPagina: 20,
            tableData: [],
            row: null,
            multipleSelection: false,
            api_uploads: _config.API_UPLOADS,
            activeRow: null,
            searchQuery: '',
            showSearch: false
        };
    },

    watch: {
        searchQuery: function searchQuery(v, a) {
            this.searchInTable();
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            this.items ? this.itemsPorPagina = this.items : false;
            setTimeout(function () {
                _this.tableData = _this.paginador();
            }, 100);
        },
        paginador: function paginador() {
            var indiceInicio = (this.currentPage - 1) * this.itemsPorPagina;
            var indiceFinal = indiceInicio + this.itemsPorPagina > this.tableQuery.length ? this.tableQuery.length : indiceInicio + this.itemsPorPagina;
            this.totalRegistros = this.tableQuery.length;
            return this.tableQuery.slice(indiceInicio, indiceFinal);
        },
        handleSizeChange: function handleSizeChange(val) {
            this.itemsPorPagina = val;
            this.tableData = this.paginador();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.currentPage = val;
            this.tableData = this.paginador();
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleEdit: function handleEdit(index, row) {
            this.$root.$emit('isConnect');

            if (this.routeEdit != 'modal') {
                row.templateId ? this.$router.push(this.routeEdit + row.id + '/' + row.templateId) : this.$router.push(this.routeEdit + row.id);
            } else {
                this.$root.$emit('openModal', row.id);
            }
        },
        handleSelect: function handleSelect(index, row) {
            this.$root.$emit('isConnect');
            this.activeRow = row.id;
            this.$root.$emit('select', row.id, row);
        },
        handleView: function handleView(row) {
            this.$root.$emit('isConnect');
            this.$router.push(this.routeView + row.id);
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            this.$root.$emit('isConnect');
            this.$confirm('Esto eliminará permanentemente el registro. ¿Continuar?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this2.$root.$emit('delete', row.id, row);
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: 'Se ha cancelado el borrado'
                });
            });
        },
        handleSidebarMultiple: function handleSidebarMultiple(value) {
            var _this3 = this;

            this.$root.$emit('isConnect');
            this.multipleSelection.forEach(function (element) {
                _this3.$root.$emit('sidebarUpdate', element.id, element, value);
            });
        },
        handleSorteableMultiple: function handleSorteableMultiple() {
            this.$root.$emit('isConnect');
            this.$root.$emit('showmodaldraggable');
        },
        handleDeleteMultiple: function handleDeleteMultiple() {
            var _this4 = this;

            this.$root.$emit('isConnect');
            this.$confirm('Esto eliminará permanentemente los registros marcados. ¿Continuar?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                if (_this4.routeDelete) {
                    _this4.multipleSelection.forEach(function (element) {
                        _this4.$root.$emit(_this4.routeDelete, element.id, element);
                    });
                } else {
                    _this4.multipleSelection.forEach(function (element) {
                        _this4.$root.$emit('delete', element.id, element);
                    });
                }
            }).catch(function () {
                _this4.$message({
                    type: 'info',
                    message: 'Se ha cancelado el borrado'
                });
            });
        },
        tableRowClassName: function tableRowClassName(row) {
            if (row.id == this.activeRow) {
                return 'success-row';
            }
        },
        searchInTable: function searchInTable() {
            var _this5 = this;

            if (this.searchQuery) {
                this.itemsPorPagina = this.tableQuery.length;
                this.tableData = this.tableQuery.filter(function (e) {
                    return _this5.tableColumns.some(function (p) {
                        if (e[p.prop] != null && typeof e[p.prop] === 'string' && e[p.prop]) {
                            return e[p.prop].toLowerCase().includes(_this5.searchQuery.toLowerCase());
                        }
                    });
                });
            } else {
                this.tableShow = false;
                this.init();
            }
        },
        hamdleSearch: function hamdleSearch() {
            this.$root.$emit('isConnect');
            this.showSearch = !this.showSearch;
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin']))
};

/***/ }),

/***/ "SLfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SZZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue__ = __webpack_require__("RhbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07047b8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tablaConPaginador_vue__ = __webpack_require__("vdvv");
function injectStyle (ssrContext) {
  __webpack_require__("hhM1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07047b8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaConPaginador_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07047b8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tablaConPaginador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SpD4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {};

/***/ }),

/***/ "UDh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',{staticStyle:{"text-align":"right","font-size":"12px"}},[_c('el-menu',{attrs:{"mode":"horizontal","background-color":"#fff","text-color":"#303133","active-text-color":"#303133"}},[_c('el-menu-item',{attrs:{"index":"0"},on:{"click":function($event){return _vm.toggle()}}},[_c('i',{staticClass:"fa fa-bars fa-2x"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VeOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('app-sidebar'),_vm._v(" "),_c('el-container',{attrs:{"direction":"vertical"}},[_c('app-content')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Dashboard = __webpack_require__("s+3R");

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Login = __webpack_require__("mJTh");

var _Login2 = _interopRequireDefault(_Login);

var _LoginGoogle = __webpack_require__("kriZ");

var _LoginGoogle2 = _interopRequireDefault(_LoginGoogle);

var _Content = __webpack_require__("ZcUT");

var _Content2 = _interopRequireDefault(_Content);

var _Usuarios = __webpack_require__("75W6");

var _Usuarios2 = _interopRequireDefault(_Usuarios);

var _Proyectos = __webpack_require__("CQP5");

var _Proyectos2 = _interopRequireDefault(_Proyectos);

var _Informes = __webpack_require__("FOpv");

var _Informes2 = _interopRequireDefault(_Informes);

var _misinformes = __webpack_require__("BED7");

var _misinformes2 = _interopRequireDefault(_misinformes);

var _usuario = __webpack_require__("R1qv");

var _usuario2 = _interopRequireDefault(_usuario);

var _informe = __webpack_require__("dTZM");

var _informe2 = _interopRequireDefault(_informe);

var _iframe = __webpack_require__("iBI/");

var _iframe2 = _interopRequireDefault(_iframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
    mode: 'history',
    cors: true,
    routes: [{
        path: '/',
        name: 'Home',
        component: _LoginGoogle2.default
    }, {
        path: '/login',
        name: 'Login',
        component: _LoginGoogle2.default
    }, {
        path: '/login2',
        name: 'Login2',
        component: _Login2.default
    }, {
        path: '/dashboard',
        name: 'Dashboard',
        component: _Dashboard2.default,
        children: [{
            path: 'usuarios',
            name: 'Usuarios',
            component: _Usuarios2.default
        }, {
            path: 'proyectos',
            name: 'proyectos',
            component: _Proyectos2.default,
            children: [{
                path: ':proyecto/informes',
                name: 'Proyectos informes',
                component: _Informes2.default
            }]
        }, {
            path: 'form/informe',
            name: 'Formulario nuevo informe',
            component: _informe2.default
        }, {
            path: 'misinformes',
            name: 'Mis informes disponibles',
            component: _misinformes2.default
        }, {
            path: 'form/informe/:informe_id',
            name: 'Formulario editar informe',
            component: _informe2.default
        }, {
            path: 'form/usuario',
            name: 'Formulario nuevo usuario',
            component: _usuario2.default
        }, {
            path: 'form/usuario/:user_id',
            name: 'Formulario editar usuario',
            component: _usuario2.default
        }, {
            path: 'informe/:informe_id',
            name: 'iframe',
            component: _iframe2.default
        }],
        meta: { requiresAuth: true }
    }]
});

/***/ }),

/***/ "Z8KC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZcUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("p0HW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ecf0662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("g00a");
function injectStyle (ssrContext) {
  __webpack_require__("Kswl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ecf0662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dTZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue__ = __webpack_require__("zhJV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1c2d3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informe_vue__ = __webpack_require__("nnHx");
function injectStyle (ssrContext) {
  __webpack_require__("PhPj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c1c2d3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informe_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1c2d3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "g00a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"custom-main",class:(_vm.$route.name == 'iframe' ? 'custom-main-iframe' : false )},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gGjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",class:_vm.classContainer},[_c('i',{staticClass:"el-icon-error",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gMEm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _tablaConPaginador = __webpack_require__("SZZG");

var _tablaConPaginador2 = _interopRequireDefault(_tablaConPaginador);

var _InformesProyecto = __webpack_require__("DM/K");

var _InformesProyecto2 = _interopRequireDefault(_InformesProyecto);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'misinformes',
    components: {
        'app-table-paginate': _tablaConPaginador2.default,
        'app-informes': _InformesProyecto2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
    created: function created() {
        var _this = this;

        this.viewReports == false ? window.localStorage.removeItem('analiticaproyectoActivo') : this.viewReport(this.viewReports, this.name);
        this.$root.$on('select', function (id) {
            _this.viewReports = false;
            setTimeout(function () {
                _this.viewReports = id;
            }, 500);
        });
        this.$root.$on('select', function (id, row) {
            return _this.viewReport(id, row.proyecto);
        });
        this.init();
    },
    data: function data() {
        return {
            loading: true,
            headers: [{
                'prop': 'proyecto',
                'label': 'Proyecto'
            }],
            field: {},
            tableQuery: {},
            relationship: [],
            routeView: null,
            viewReports: false
        };
    },

    watch: {
        $route: function $route(to) {
            this.loading = true;
            this.tableQuery = {};
            this.headers = [];
            this.init();
        }
    },
    methods: {
        init: function init() {
            this.getTableData();
        },
        getTableData: function getTableData() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['proyectos.id', 'proyectos.proyecto'],
                                    table: 'proyectos',
                                    inner: ['users_projects, project_id, id, proyectos', 'users, id, user_id, users_projects'],
                                    where: ' users.id = ' + _this2.currentUser.id,
                                    order: [' proyectos.id DESC']

                                }).then(function (response) {
                                    if (response.data == 'Algo ha fallado') {
                                        _this2.tableData = [];
                                    } else {
                                        _this2.tableData = response.data;
                                    }
                                    setTimeout(function () {
                                        _this2.loading = false;
                                    }, 200);
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        viewReport: function viewReport(id, name) {
            var _this3 = this;

            this.viewReports = false;
            this.$root.$emit('sidebar', id);
            setTimeout(function () {
                _this3.viewReports = id;
                _this3.name = name;
            }, 500);
        }
    }
};

/***/ }),

/***/ "gRp0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jwtDecode = __webpack_require__("ytdl");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var User = function () {
  (0, _createClass3.default)(User, null, [{
    key: 'from',
    value: function from(token) {
      try {
        var obj = (0, _jwtDecode2.default)(token);
        return new User(obj.data);
      } catch (_) {
        return null;
      }
    }
  }]);

  function User(_ref) {
    var user_id = _ref.user_id,
        rol = _ref.rol,
        email = _ref.email,
        name = _ref.name,
        token = _ref.token;
    (0, _classCallCheck3.default)(this, User);

    this.id = user_id;
    this.rol = rol;
    this.email = email;
    this.token = token;
    this.name = name;
    this.admin = false;
  }

  (0, _createClass3.default)(User, [{
    key: 'isAdmin',
    get: function get() {
      return this.rol;
    }
  }]);
  return User;
}();

exports.default = User;

/***/ }),

/***/ "ghFu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _tablaConPaginador = __webpack_require__("SZZG");

var _tablaConPaginador2 = _interopRequireDefault(_tablaConPaginador);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Informes',
    components: {
        'app-table-paginate': _tablaConPaginador2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin'])),
    created: function created() {
        var _this = this;

        if (!this.isAdmin) {
            this.$router.replace('/dashboard/misinformes');
        }
        this.routeView = 'informe/';
        this.routeEdit = '/dashboard/form/informe/';
        this.init();
        this.$root.$on('delete', function (id) {
            _this.eliminarRegistro(id);
        });
    },
    data: function data() {
        return {
            loading: true,
            headers: [{
                'prop': 'icono',
                'label': 'Icono'
            }, {
                'prop': 'nombre',
                'label': 'Nombre'
            }, {
                'prop': 'url',
                'label': 'URl'
            }],
            field: {},
            tableQuery: {},
            nametable: this.$route.params.table,
            relationship: [],
            routeEdit: null,
            deleterow: false
        };
    },

    watch: {
        $route: function $route(to) {
            this.loading = true;
            this.tableQuery = {};
            this.headers = [];
            this.routeEdit = '/dashboard/form/informe/';
            this.init();
        }
    },
    methods: {
        init: function init() {
            this.getTableData();
        },
        nuevoRegistro: function nuevoRegistro() {
            this.$router.push('/dashboard/form/informe/');
        },
        getTableData: function getTableData() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['informes.id', 'informes.nombre', 'informes.descripcion', 'informes.url, informes.icono'],
                                    table: 'informes',
                                    order: [' informes.id DESC']
                                }).then(function (response) {
                                    if (response.data == 'Algo ha fallado') {
                                        _this2.tableData = [];
                                    } else {
                                        _this2.tableData = response.data;
                                    }
                                    setTimeout(function () {
                                        _this2.loading = false;
                                    }, 100);
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        eliminarRegistro: function eliminarRegistro(id) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.loading = true;
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    method: 'DELETE',
                                    id: id,
                                    table: 'informes'
                                }).then(function (response) {
                                    if (response.data == 1) {
                                        _this3.$root.$emit('msgSuccess', 'Registro ELIMINADO');
                                        setTimeout(function () {
                                            _this3.init();
                                        }, 1000);
                                    } else {
                                        _this3.$root.$emit('msgError', 'Algo ha fallado');
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "hCAS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('span',{staticClass:"el-breadcrumb__item"},[_c('span',{staticClass:"el-breadcrumb__inner is-link",attrs:{"role":"link"},on:{"click":_vm.cleanReport}},[_vm._v("Proyectos")]),_vm._v(" "),_c('span',{staticClass:"el-breadcrumb__separator",attrs:{"role":"presentation"}},[_vm._v("/")])]),_vm._v(" "),(_vm.name)?_c('span',{staticClass:"el-breadcrumb__item "},[_c('span',{staticClass:"el-breadcrumb__inner color-primary",attrs:{"role":"link"}},[_vm._v("Proyecto "+_vm._s(_vm.name))])]):_vm._e()],1),_vm._v(" "),(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('el-row',{attrs:{"type":"flex","align":"stretch"}},[_c('el-col',{class:(_vm.viewReports ? 'separador' : false),attrs:{"span":7}},[_c('app-table-paginate',{attrs:{"routeEdit":'modal',"routeDelete":(_vm.currentUser.rol == 1 ? true : false),"routeView":false,"routeSelect":true,"tableQuery":_vm.tableData,"tableColumns":_vm.headers,"multipleSelect":false,"search":true}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.currentUser.rol == 1)?_c('button',{staticClass:"el-button el-button--primary el-button--medium",attrs:{"type":"primary","form":"a"},on:{"click":function($event){return _vm.newProject()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-plus-outline"}),_vm._v("Proyecto")])]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_c('i',{staticClass:"el-icon-circle-plus-outline"}),_vm._v(" Cuadro de mando")]),_vm._v(" "),(_vm.addNewProject)?_c('app-modal-new-project',{attrs:{"project":_vm.project_id}}):_vm._e()],1),_vm._v(" "),_c('el-col',{class:(_vm.viewReports ? 'bg--white' : false),attrs:{"span":17}},[(_vm.viewReports)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('app-informes',{attrs:{"project":_vm.viewReports}})],1):_vm._e()],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("Usuarios")])],1),_vm._v(" "),(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('br'),_vm._v(" "),_c('app-table-paginate',{attrs:{"routeEdit":_vm.routeEdit,"routeDelete":true,"tableQuery":_vm.tableData,"tableColumns":_vm.headers}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo "),_c('i',{staticClass:"el-icon-circle-plus-outline el-icon-right"})])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "haaW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("Informes")])],1),_vm._v(" "),(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('br'),_vm._v(" "),_c('app-table-paginate',{attrs:{"routeEdit":_vm.routeEdit,"routeDelete":true,"routeView":_vm.routeView,"tableQuery":_vm.tableData,"tableColumns":_vm.headers}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo "),_c('i',{staticClass:"el-icon-circle-plus-outline el-icon-right"})])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hgdF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (errorValue) {
    return "" + errorValue[0];
};

/***/ }),

/***/ "hhM1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iBI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue__ = __webpack_require__("Lg1e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe93c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_iframe_vue__ = __webpack_require__("H1JQ");
function injectStyle (ssrContext) {
  __webpack_require__("2rFN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe93c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_iframe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iTXB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "imQP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ipBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[(_vm.addNewProject)?_c('app-modal-new-project'):_vm._e(),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/dashboard/usuarios' }}},[_vm._v("Usuarios")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.breadcrumb))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"label-position":"top","id":"user"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"Email"}},[_c('el-input',{model:{value:(_vm.form.user),callback:function ($$v) {_vm.$set(_vm.form, "user", $$v)},expression:"form.user"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"Contraseña"}},[_c('el-input',{model:{value:(_vm.form.pass),callback:function ($$v) {_vm.$set(_vm.form, "pass", $$v)},expression:"form.pass"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"Nombre"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}}),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-form-item',{attrs:{"label":"Nivel de acceso"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.level_id),expression:"form.level_id"}],staticClass:"select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "level_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.levels),function(l,i){return _c('option',{key:i,domProps:{"value":l.id}},[_vm._v(_vm._s(l.name))])}),0)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}}),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"Proyectos asociados"}},[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},on:{"change":_vm.changueProjectc,"remove-tag":_vm.deleteProjectc},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}},_vm._l((_vm.proyectos),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.proyecto,"value":item.id}})}),1),_vm._v(" "),_c('button',{staticClass:"el-button",attrs:{"type":"text","form":"a"},on:{"click":function($event){return _vm.addProject()}}},[_c('span',[_vm._v("Añadir nuevo proyecto")])])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('br'),_vm._v(" "),(this.showBottons)?_c('button',{staticClass:"el-button el-button--primary",attrs:{"type":"submit","form":"user"}},[_c('span',[_vm._v(_vm._s(_vm.btn))])]):_vm._e(),_vm._v(" "),(!_vm.$route.params.user_id)?_c('el-button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("Cancelar")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jltm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _vuex = __webpack_require__("NYxO");

var _actions = __webpack_require__("lHQJ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: "sidebar",
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin', 'currentUser', 'getSidebar', 'getShowSidebar'])),
	created: function created() {
		var _this = this;

		this.$route.params.informe_id ? this.activeIndex = this.$route.params.informe_id : this.activeIndex = this.$route.name;
		this.$root.$on('sidebar', function (id) {
			window.localStorage.setItem('analiticaproyectoActivo', id);
			_this.project_id = id;
			_this.showSidebar = false;
			_this.init();
		});
		setTimeout(function () {
			if (window.localStorage.getItem('analiticaproyectoActivo')) {
				_this.project_id = window.localStorage.getItem('analiticaproyectoActivo');
				_this.showSidebar = false;
				_this.init();
			}
		}, 500);
		setTimeout(function () {
			_this.isCollapse = _this.getShowSidebar;
		}, 500);
		this.$root.$on("toogleChange", function () {
			_this.toggle();
		});
	},
	data: function data() {
		return {
			links: null,
			isCollapse: true,
			activeIndex: 'informes',
			project_id: null,
			showSidebar: false
		};
	},

	watch: {
		$route: function $route(newRoute, oldRoute) {
			this.$router.go(this.$router.currentRoute);
		}
	},
	methods: {
		init: function init() {
			var _this2 = this;

			this.getReports();
			setTimeout(function () {
				_this2.showSidebar = true;
			}, 500);
		},
		findActiveLink: function findActiveLink() {
			if (localStorage.getItem("analiticauser")) {
				var obj = localStorage.getItem("analiticatoken");
			}
		},
		cambio: function cambio(href) {
			this.$root.$emit('isConnect');
			this.$router.push(href);
		},
		toggle: function toggle() {
			this.isCollapse = !this.isCollapse;
		},
		getReports: function getReports() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_api2.default.post("public/v1", {
									token: localStorage.getItem("analiticatoken"),
									single: false,
									method: 'SELECT',
									fields: ['informes.id', 'informes.icono', 'informes.url', 'informes.nombre', 'informes.descripcion'],
									inner: ['reports_projects, report_id, id, informes'],
									where: ' informes.visible = 1 AND reports_projects.project_id = ' + _this3.project_id,
									table: 'informes',
									groupby: ' informes.id',
									order: [' informes.order_row']
								}).then(function (response) {
									if (response.data != 'Algo ha fallado') {
										_this3.links = response.data;
									}
									setTimeout(function () {
										_this3.loading = false;
									}, 200);
								});

							case 1:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		handleSelect: function handleSelect(key, keyPath) {},
		desconectar: function desconectar() {
			var _this4 = this;

			this.$store.dispatch(_actions.LOGOUT).then(function () {
				_this4.$router.go('/login');
				window.localStorage.removeItem('analiticaproyectoActivo');
			});
		}
	},
	mounted: function mounted() {
		this.findActiveLink();
		this.table = this.$route.params.db;
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "kriZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue__ = __webpack_require__("1tpP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25593aef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginGoogle_vue__ = __webpack_require__("y8lV");
function injectStyle (ssrContext) {
  __webpack_require__("HLUH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginGoogle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25593aef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginGoogle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lETE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_vm._v("\n  Footer\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHQJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN = exports.LOGIN = 'LOGIN';
var LOGIN_GOOGLE = exports.LOGIN_GOOGLE = 'LOGIN_GOOGLE';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var CHECK_AUTH = exports.CHECK_AUTH = 'CHECK_AUTH';
var RECOVERY_PASS = exports.RECOVERY_PASS = 'RECOVERY_PASS';
var FECTH_AUTH = exports.FECTH_AUTH = 'FECTH_AUTH';

var FECTH_SIDEBAR = exports.FECTH_SIDEBAR = 'FECTH_SIDEBAR';
var FECTH_SHOW_SIDEBAR = exports.FECTH_SHOW_SIDEBAR = 'FECTH_SHOW_SIDEBAR';

/***/ }),

/***/ "mJTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("04Xd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3bad4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("mrhh");
function injectStyle (ssrContext) {
  __webpack_require__("xMRu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3bad4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mo8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__ = __webpack_require__("5YTu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460c83aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_draggable_vue__ = __webpack_require__("3wrT");
function injectStyle (ssrContext) {
  __webpack_require__("R/jh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-460c83aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460c83aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_draggable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mrhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-body"},[_c('form',{staticClass:"el-form",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('input',{attrs:{"type":"hidden","value":"1","name":"enviar"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item"},[_c('div',{staticClass:"el-form-item__content"},[_c('div',{staticClass:"el-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.user),expression:"form.user"}],staticClass:"el-input__inner",attrs:{"type":"text","autocomplete":"off","placeholder":"Usuario"},domProps:{"value":(_vm.form.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "user", $event.target.value)}}})])])]),_vm._v(" "),(_vm.formLogin)?_c('div',{staticClass:"el-form-item"},[_c('div',{staticClass:"el-form-item__content"},[_c('div',{staticClass:"el-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.pass),expression:"form.pass"}],staticClass:"el-input__inner",attrs:{"type":"password","autocomplete":"off","placeholder":"Contraseña"},domProps:{"value":(_vm.form.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "pass", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"result"}),_vm._v(" "),_c('div',{staticClass:"el-form-item"},[_c('div',{staticClass:"el-form-item__content"},[_c('button',{staticClass:"el-button el-button--submit",attrs:{"type":"submit"}},[_c('span',[_vm._v(_vm._s(_vm.btn))])]),_vm._v(" "),_c('button',{staticClass:"el-button",attrs:{"type":"texty"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',[_vm._v("Atrás")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-header"},[_c('a',{staticClass:"logo",attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"/static/logo_color.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mtlE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _tablaConPaginador = __webpack_require__("SZZG");

var _tablaConPaginador2 = _interopRequireDefault(_tablaConPaginador);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Usuarios',
    components: {
        'app-table-paginate': _tablaConPaginador2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin', 'currentUser'])),
    created: function created() {
        var _this = this;

        if (this.currentUser.rol != 1) {
            this.currentUser.rol == 3 ? this.$router.replace('/dashboard/proyectos') : this.$router.replace('/dashboard/misinformes');
        }

        this.routeEdit = '/dashboard/form/usuario/';
        this.init();
        this.$root.$on('delete', function (id) {
            _this.eliminarRegistro(id);
        });
    },
    data: function data() {
        return {
            loading: true,
            headers: [{
                'prop': 'nombre',
                'label': 'Nombre'
            }, {
                'prop': 'user',
                'label': 'Usuario'
            }, {
                'prop': 'name',
                'label': 'Nivel'
            }],
            field: {},
            tableQuery: {},
            nametable: this.$route.params.table,
            relationship: [],
            routeEdit: null,
            deleterow: false,
            proyectos: []
        };
    },

    watch: {
        $route: function $route(to) {
            this.loading = true;
            this.tableQuery = {};
            this.headers = [];
            this.routeEdit = '/dashboard/form/usuario/';
            this.init();
        }
    },
    methods: {
        init: function init() {
            var _this2 = this;

            this.getProjects();
            setTimeout(function () {
                _this2.getTableData();
            }, 100);
        },
        nuevoRegistro: function nuevoRegistro() {
            this.$router.push('/dashboard/form/usuario/');
        },
        getProjects: function getProjects() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['id', 'proyecto'],
                                    table: 'proyectos'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this3.proyectos = response.data;
                                    } else {
                                        _this3.proyectos = [];
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        getTableData: function getTableData() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['users.id', 'users.name as nombre', 'users.user', 'users.pass', 'users.level_id', 'levels.name'],
                                    table: 'users',
                                    order: [' users.id DESC'],
                                    inner: ['levels, id, level_id, users']
                                }).then(function (response) {
                                    if (response.data == 'Algo ha fallado') {
                                        _this4.tableData = [];
                                    } else {
                                        _this4.tableData = response.data;
                                        _this4.tableData = response.data.map(function (a) {
                                            _this4.proyectos.forEach(function (e) {
                                                if (a.project == parseInt(e.id)) {
                                                    a.project = e.proyecto;
                                                } else if (a.project == 0) {
                                                    a.project = 'Proyecto no asignado';
                                                }
                                            });
                                            return a;
                                        });
                                    }
                                    setTimeout(function () {
                                        _this4.loading = false;
                                    }, 300);
                                });

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        eliminarRegistro: function eliminarRegistro(id) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this5.loading = true;
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    method: 'DELETE',
                                    id: id,
                                    table: 'users'
                                }).then(function (response) {
                                    if (response.data == 1) {
                                        _this5.$root.$emit('msgSuccess', 'Registro ELIMINADO');
                                        setTimeout(function () {
                                            _this5.init();
                                        }, 1000);
                                    } else {
                                        _this5.$root.$emit('msgError', 'Algo ha fallado');
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "nnHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[(_vm.addNewProject)?_c('app-modal-new-project'):_vm._e(),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Inicio")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/dashboard/proyectos' }}},[_vm._v("Proyectos")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.breadcrumb))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"label-position":"top","id":"user"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Icono"}},[_c('el-input',{attrs:{"prefix-icon":_vm.form.icono},model:{value:(_vm.form.icono),callback:function ($$v) {_vm.$set(_vm.form, "icono", $$v)},expression:"form.icono"}}),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"https://glyphsearch.com/?copy=class&library=ionicons","target":"_blank"}},[_vm._v("ionicons")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"Nombre"}},[_c('el-input',{model:{value:(_vm.form.nombre),callback:function ($$v) {_vm.$set(_vm.form, "nombre", $$v)},expression:"form.nombre"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"URl"}},[_c('el-input',{on:{"change":function($event){return _vm.setIframe()}},model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", $$v)},expression:"form.url"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Ancho iframe"}},[_c('el-input',{model:{value:(_vm.form.width),callback:function ($$v) {_vm.$set(_vm.form, "width", $$v)},expression:"form.width"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}}),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Alto iframe"}},[_c('el-input',{model:{value:(_vm.form.height),callback:function ($$v) {_vm.$set(_vm.form, "height", $$v)},expression:"form.height"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}}),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Proyecto asociado"}},[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},on:{"change":_vm.changueProjectc,"remove-tag":_vm.deleteProjectc},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}},_vm._l((_vm.proyectos),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.proyecto,"value":item.id}})}),1),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addProject()}}},[_vm._v("Añadir nuevo proyecto")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}}),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"Visble en menú"}},[_c('el-radio-group',{model:{value:(_vm.form.visible),callback:function ($$v) {_vm.$set(_vm.form, "visible", $$v)},expression:"form.visible"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("Sí")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("No")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"Descripción"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 4}},model:{value:(_vm.form.descripcion),callback:function ($$v) {_vm.$set(_vm.form, "descripcion", $$v)},expression:"form.descripcion"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[(_vm.showIframe)?_c('el-form-item',{attrs:{"label":"Previsualización"}},[_c('iframe',{attrs:{"src":_vm.form.url,"width":"100%","height":"400","frameborder":"0"}})]):_vm._e()],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('button',{staticClass:"el-button el-button--primary",attrs:{"type":"submit","form":"user"}},[_c('span',[_vm._v(_vm._s(_vm.btn))])]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.close()}}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p0HW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//

exports.default = {
	name: 'Content'
};

/***/ }),

/***/ "pZZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("SpD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16eedad5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("lETE");
function injectStyle (ssrContext) {
  __webpack_require__("imQP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16eedad5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pgpf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s+3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("0tZ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d200a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("VeOH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d200a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v0TN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vUI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("QiRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afb7322_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("UDh6");
function injectStyle (ssrContext) {
  __webpack_require__("SLfZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4afb7322"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afb7322_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vdvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.multipleSelection.length > 0 && _vm.draggable)?_c('el-button',{on:{"click":function($event){return _vm.handleSorteableMultiple()}}},[_c('i',{staticClass:"el-icon-d-caret"})]):_vm._e(),_vm._v(" "),(_vm.multipleSelection.length > 0 && _vm.sidebar && _vm.isAdmin)?_c('el-button',{on:{"click":function($event){return _vm.handleSidebarMultiple(1)}}},[_vm._v("Mostrar en menú")]):_vm._e(),_vm._v(" "),(_vm.multipleSelection.length > 0 && _vm.sidebar && _vm.isAdmin)?_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.handleSidebarMultiple(0)}}},[_vm._v("No mostrar en menú")]):_vm._e(),_vm._v(" "),(_vm.multipleSelection.length > 0 && _vm.isAdmin)?_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.handleDeleteMultiple()}}},[_vm._v("Eliminar registros")]):_vm._e(),_vm._v(" "),(_vm.search)?_c('el-button',{staticClass:"btn--custom-mini custom--search",attrs:{"size":"mini"},on:{"click":function($event){return _vm.hamdleSearch()}}},[_c('i',{staticClass:"el-icon-search"})]):_vm._e(),_vm._v(" "),(_vm.showSearch)?_c('el-form',{ref:"form",staticClass:"custom--input--search",attrs:{"size":"mini","label-position":'left',"label-width":"125px"}},[_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Busqueda","prefix-icon":"el-icon-search","name":"buscador"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-table',{ref:"multipleTable",class:_vm.customclass,attrs:{"data":_vm.tableData},on:{"selection-change":_vm.handleSelectionChange}},[(_vm.multipleSelect)?_c('el-table-column',{attrs:{"type":"selection","width":"55"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.tableColumns),function(c,i){return (c.label == 'Icono')?_c('el-table-column',{key:i,attrs:{"prop":c.prop,"label":c.label,"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{class:scope.row.icono})]}}],null,true)}):_vm._e()}),_vm._v(" "),_vm._l((_vm.tableColumns),function(c,i){return (c.label == 'Nombre')?_c('el-table-column',{key:i,attrs:{"prop":c.prop,"label":c.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.descripcion)?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v(_vm._s(scope.row.descripcion))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('el-tag',{attrs:{"size":"medium"}},[_vm._v(_vm._s(scope.row.nombre))])],1)]):_c('div',{staticClass:"cell"},[_vm._v(_vm._s(scope.row.nombre))])]}}],null,true)}):_vm._e()}),_vm._v(" "),_vm._l((_vm.tableColumns),function(c,i){return (c.label == 'Menú')?_c('el-table-column',{key:i,attrs:{"prop":c.prop,"label":c.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.visible == 'No')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.visible))]):_c('div',{staticClass:"cell"},[_vm._v(_vm._s(scope.row.visible))])]}}],null,true)}):_vm._e()}),_vm._v(" "),_vm._l((_vm.tableColumns),function(c,i){return (c.label == 'Proyecto')?_c('el-table-column',{key:i,attrs:{"prop":c.prop,"label":c.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"cell pointer",on:{"click":function($event){$event.preventDefault();return _vm.handleSelect(i, scope.row)}}},[_vm._v(_vm._s(scope.row.proyecto))])]}}],null,true)}):_vm._e()}),_vm._v(" "),_vm._l((_vm.tableColumns),function(c,i){return (c.label != 'Icono' && c.label != 'Nombre' && c.label != 'Menú' && c.label != 'Proyecto')?_c('el-table-column',{key:i,attrs:{"prop":c.prop,"label":c.label,"sortable":""}}):_vm._e()}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acciones"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.routeSelect)?_c('el-button',{staticClass:"btn--custom-mini btn--custom-hover",attrs:{"size":"mini"},on:{"click":function($event){return _vm.handleSelect(scope.$index, scope.row)}}},[_c('i',{staticClass:"el-icon-zoom-in"})]):_vm._e(),_vm._v(" "),(_vm.routeView)?_c('el-button',{staticClass:"btn--custom-mini",attrs:{"size":"mini","type":"info"},on:{"click":function($event){return _vm.handleView(scope.row)}}},[_c('i',{staticClass:"el-icon-view"})]):_vm._e(),_vm._v(" "),(_vm.routeEdit)?_c('el-button',{staticClass:"btn--custom-mini",attrs:{"size":"mini"},on:{"click":function($event){return _vm.handleEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"el-icon-edit"})]):_vm._e(),_vm._v(" "),(_vm.routeDelete)?_c('el-button',{staticClass:"btn--custom-mini",attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],2),_vm._v(" "),(_vm.totalRegistros > _vm.itemsPorPagina)?_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"layout":"total, sizes, prev, pager, next","total":_vm.totalRegistros},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wYMm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
var TOKEN_APP = exports.TOKEN_APP = 'lU1mMYl9t0msQ7lGKgXRpwpmp6bzaSV02WLA47uA43Lg';

var BASE_URL = exports.BASE_URL = 'https://analitica.grdar.es/api/public';
var API_URL = exports.API_URL = BASE_URL + '/';
var API_UPLOADS = exports.API_UPLOADS = BASE_URL;

/***/ }),

/***/ "xJ/v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _sha = __webpack_require__("uXeI");

var _sha2 = _interopRequireDefault(_sha);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _addNewProject = __webpack_require__("yWLa");

var _addNewProject2 = _interopRequireDefault(_addNewProject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'usuario',
    components: {
        'app-modal-new-project': _addNewProject2.default
    },
    created: function created() {
        var _this = this;

        this.$root.$on('closeModal', function () {
            _this.addNewProject = false;
            _this.getProjects();
        });

        if (this.$route.params.user_id) {
            this.breadcrumb = 'Edición usuario';
            this.btn = 'Actualizar';
            this.id = this.$route.params.user_id;
            setTimeout(function () {
                _this.getLevels();
                _this.getUser();
                setTimeout(function () {
                    _this.getProject();
                }, 100);
            }, 200);
        } else {
            this.breadcrumb = 'Nuevo usuario';
            this.getLevels();
        }
        this.getProjects();

        this.showBottons = true;
    },
    data: function data() {
        return {
            id: null,
            btn: 'Crear',
            form: {
                user: null,
                pass: null,
                level_id: 2,
                name: null
            },
            project: [],
            proyecto: {
                id: null,
                proyecto: null
            },
            proyectos: null,
            levels: {},
            passOld: null,
            addNewProject: false,
            proyectoOld: null,
            error: true,
            borrado: false
        };
    },

    methods: {
        getLevels: function getLevels() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    table: 'levels'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this2.levels = response.data;
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getUser: function getUser() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'select',
                                    fields: ['user', 'pass', 'level_id', 'name'],
                                    where: ' id = ' + _this3.id,
                                    table: 'users'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this3.form = response.data;
                                        _this3.passOld = response.data.pass;
                                    }
                                    setTimeout(function () {
                                        _this3.loading = false;
                                    }, 100);
                                });

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        getProject: function getProject() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'SELECT',
                                    fields: ['id', 'project_id'],
                                    where: ' user_id = ' + _this4.id,
                                    table: 'users_projects'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this4.project = response.data.map(function (e) {
                                            return e.project_id;
                                        });
                                        _this4.proyecto = response.data;
                                        _this4.proyectoOld = response.data;
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        getProjects: function getProjects() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['id', 'proyecto'],
                                    table: 'proyectos'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this5.proyectos = response.data;
                                    } else {
                                        _this5.proyectos = [];
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        save: function save() {
            this.$root.$emit('isConnect');
            if (this.form.user == '') {
                this.$root.$emit('msgError', 'El campo Email es obligatorio');
                this.error = true;
                return false;
            } else {
                this.error = false;
            }
            if (this.form.pass == '') {
                this.$root.$emit('msgError', 'El campo contraseña es obligatorio');
                this.error = true;
                return false;
            } else {
                this.error = false;
            }

            if (this.error == false) {
                if (this.passOld != this.form.pass) {
                    this.form.pass = (0, _sha2.default)(this.form.pass);
                }
                this.id > 0 ? this.update() : this.insert();
            }
        },
        insert: function insert() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'INSERT',
                                    table: 'users',
                                    form: _this6.form
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado' && response.data != "El usuario ya existe") {
                                        _this6.$root.$emit('msgSuccess', 'Registro insertado');
                                        setTimeout(function () {
                                            _this6.$router.push('/dashboard/usuarios');
                                        }, 1000);
                                    } else {
                                        _this6.$root.$emit('msgError', response.data);
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },
        update: function update() {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'UPDATE',
                                    id: _this7.id,
                                    table: 'users',
                                    form: _this7.form
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this7.$root.$emit('msgSuccess', 'Registro actualizado');
                                        setTimeout(function () {
                                            _this7.$router.push('/dashboard/usuarios');
                                        }, 1000);
                                    } else {
                                        _this7.$root.$emit('msgError', 'Algo ha fallado');
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },
        addProject: function addProject() {
            this.addNewProject = true;
        },
        deleteProjectc: function deleteProjectc(e) {
            if (this.id) {
                this.borrado = e;
            }
        },
        changueProjectc: function changueProjectc(e) {
            var _this8 = this;

            this.$root.$emit('isConnect');
            setTimeout(function () {
                if (_this8.id) {
                    if (_this8.borrado == false) {
                        _api2.default.post("public/v1", {
                            token: localStorage.getItem("analiticatoken"),
                            single: true,
                            method: 'INSERT',
                            table: 'users_projects',
                            form: {
                                user_id: _this8.id,
                                project_id: parseInt(e[e.length - 1])
                            }
                        }).then(function (response) {
                            _this8.$root.$emit('msgSuccess', 'Registro actualizado con éxito');
                        });
                    } else {
                        _this8.proyectoOld.filter(function (p) {
                            if (_this8.borrado == p.project_id) {
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'DELETE',
                                    id: p.id,
                                    table: 'users_projects'
                                }).then(function (response) {
                                    _this8.$root.$emit('msgSuccess', 'Registro actualizado con éxito');
                                });
                                _this8.borrado = false;
                            }
                        });
                    }
                }
            }, 500);
        },
        close: function close() {
            this.$root.$emit('isConnect');
            this.$router.push('/dashboard/usuarios');
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__("NYxO");

exports.default = {
    name: "app"
}; //
//
//
//
//
//

/***/ }),

/***/ "xMRu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xaox":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _tablaConPaginador = __webpack_require__("SZZG");

var _tablaConPaginador2 = _interopRequireDefault(_tablaConPaginador);

var _InformesProyecto = __webpack_require__("DM/K");

var _InformesProyecto2 = _interopRequireDefault(_InformesProyecto);

var _addNewProject = __webpack_require__("yWLa");

var _addNewProject2 = _interopRequireDefault(_addNewProject);

var _vuex = __webpack_require__("NYxO");

var _draggable = __webpack_require__("mo8Y");

var _draggable2 = _interopRequireDefault(_draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Proyectos',
    components: {
        'app-table-paginate': _tablaConPaginador2.default,
        'app-informes': _InformesProyecto2.default,
        'app-modal-new-project': _addNewProject2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin', 'currentUser'])),
    created: function created() {
        var _this = this;

        this.viewReports == false ? window.localStorage.removeItem('analiticaproyectoActivo') : this.viewReport(this.viewReports, this.name);

        if (!this.isAdmin) {
            this.$router.replace('/dashboard/misinformes');
        }
        this.$root.$on('closeModal', function () {
            _this.addNewProject = false;
            _this.init();
        });
        setTimeout(function () {
            _this.init();
        }, 100);

        this.$root.$on('select', function (id, row) {
            return _this.viewReport(id, row.proyecto);
        });

        this.$root.$on('openModal', function (id) {
            _this.project_id = id;
            setTimeout(function () {
                _this.addProject();
            }, 500);
        });

        this.$root.$on('delete', function (id) {
            return _this.eliminarRegistro(id);
        });
    },
    data: function data() {
        return {
            loading: true,
            headers: [{
                'prop': 'proyecto',
                'label': 'Proyecto'
            }],
            field: {},
            tableQuery: {},
            relationship: [],
            routeEdit: null,
            deleterow: false,
            viewReports: false,
            addNewProject: false,
            project_id: null,
            name: false
        };
    },

    watch: {
        $route: function $route(to) {
            this.viewReports = false;
            this.loading = true;
            this.tableQuery = {};
            this.headers = [];
            this.routeEdit = '/dashboard/form/informe/';
            this.init();
        }
    },
    methods: {
        init: function init() {
            this.loading = true;
            this.getTableData();
        },
        viewReport: function viewReport(id, name) {
            var _this2 = this;

            this.viewReports = false;
            this.$root.$emit('sidebar', id);
            setTimeout(function () {
                _this2.viewReports = id;
                _this2.name = name;
            }, 500);
        },
        cleanReport: function cleanReport() {
            this.viewReports = false;
            this.name = false;
        },
        addProject: function addProject() {
            this.addNewProject = true;
        },
        newProject: function newProject() {
            var _this3 = this;

            this.$root.$emit('isConnect');
            this.project_id = null;
            setTimeout(function () {
                _this3.addNewProject = true;
            }, 100);
        },
        nuevoRegistro: function nuevoRegistro() {
            this.$root.$emit('isConnect');
            this.$router.push('/dashboard/form/informe/');
        },
        getTableData: function getTableData() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                data = void 0;


                                if (_this4.currentUser.rol == 1) {
                                    data = {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: false,
                                        method: 'select',
                                        fields: ['proyectos.id', 'proyectos.proyecto'],
                                        table: 'proyectos',
                                        order: [' proyectos.proyecto ASC']
                                    };
                                } else if (_this4.currentUser.rol == 3) {
                                    data = {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: false,
                                        method: 'select',
                                        fields: ['proyectos.id', 'proyectos.proyecto'],
                                        inner: ['users_projects, project_id, id, proyectos'],
                                        table: 'proyectos',
                                        order: [' proyectos.proyecto ASC'],
                                        where: ' users_projects.user_id = ' + _this4.currentUser.id
                                    };
                                }

                                _api2.default.post("public/v1", data).then(function (response) {
                                    if (response.data == 'Algo ha fallado') {
                                        _this4.tableData = [];
                                    } else {
                                        var a = [{
                                            id: '0',
                                            proyecto: 'Informes sin asignar'
                                        }];
                                        _this4.tableData = a.concat(response.data);
                                    }
                                    setTimeout(function () {
                                        _this4.loading = false;
                                    }, 200);
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        eliminarRegistro: function eliminarRegistro(id) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this5.loading = true;
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    method: 'DELETE',
                                    id: id,
                                    table: 'proyectos'
                                }).then(function (response) {
                                    if (response.data == 1) {
                                        _this5.$root.$emit('msgSuccess', 'Registro ELIMINADO');
                                        setTimeout(function () {
                                            _this5.init();
                                        }, 1000);
                                    } else {
                                        // this.$root.$emit('msgError', 'Algo ha fallado')
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            }))();
        }
    }
};

/***/ }),

/***/ "y8lV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login--container"},[_c('el-card',[_c('div',{staticClass:"login--header"},[_c('a',{staticClass:"logo",attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"/static/logo_color.png"}})]),_vm._v(" "),_c('el-button-group',{staticClass:"btn--group"},[_c('g-signin-button',{staticClass:"g-signin2",attrs:{"data-theme":"white","data-longtitle":"true","params":_vm.googleSignInParams},on:{"success":_vm.onSignInSuccess,"error":_vm.onSignInError}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn--login el-button el-button--default",attrs:{"href":"/login2"}},[_vm._v("Or use login Grdar")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yWLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue__ = __webpack_require__("/9jR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b68e0a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewProject_vue__ = __webpack_require__("GhYi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewProject_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b68e0a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zhJV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _sha = __webpack_require__("uXeI");

var _sha2 = _interopRequireDefault(_sha);

var _api = __webpack_require__("LguZ");

var _api2 = _interopRequireDefault(_api);

var _addNewProject = __webpack_require__("yWLa");

var _addNewProject2 = _interopRequireDefault(_addNewProject);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'report',
    components: {
        'app-modal-new-project': _addNewProject2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isAdmin', 'currentUser'])),
    created: function created() {
        var _this = this;

        this.$root.$emit('isConnect');
        this.$root.$on('closeModal', function () {
            _this.addNewProject = false;
            _this.getProjects();
        });

        if (this.$route.params.informe_id) {
            this.breadcrumb = 'Edición informe';
            this.btn = 'Actualizar';
            this.id = this.$route.params.informe_id;
            setTimeout(function () {
                setTimeout(function () {
                    _this.getProject();
                }, 100);
                _this.getReport();
            }, 200);
        } else {
            this.breadcrumb = 'Nuevo informe';
        }
        this.getProjects();
        this.showBottons = true;
    },
    data: function data() {
        return {
            id: null,
            btn: 'Crear',
            form: {
                icono: null,
                url: null,
                nombre: null,
                descripcion: null,
                user_id: null,
                visible: null,
                width: 1366,
                height: 1000
            },
            old: {
                icono: null,
                url: null,
                nombre: null,
                descripcion: null,
                user_id: null,
                visible: null,
                width: 1366,
                height: 1000

            },
            project: [],
            proyecto: {
                id: null,
                proyecto: null
            },
            proyectos: null,
            borrado: false,
            addNewProject: false,
            users: null,
            showIframe: false,
            error: false
        };
    },

    methods: {
        getProject: function getProject() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'SELECT',
                                    fields: ['id', 'project_id'],
                                    where: ' report_id = ' + _this2.id,
                                    table: 'reports_projects'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this2.project = response.data.map(function (e) {
                                            return e.project_id;
                                        });
                                        _this2.proyecto = response.data;
                                        _this2.proyectoOld = response.data;
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getProjects: function getProjects() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var data;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                data = {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: false,
                                    method: 'select',
                                    fields: ['id', 'proyecto'],
                                    table: 'proyectos'
                                };

                                if (_this3.currentUser.rol != 1) {
                                    data.fields = ['proyectos.*'], data.inner = ['users_projects, project_id, id, proyectos'], data.where = ' users_projects.user_id = ' + _this3.currentUser.id;
                                }
                                _api2.default.post("public/v1", data).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this3.proyectos = response.data;
                                    } else {
                                        _this3.proyectos = [];
                                    }
                                });

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        getReport: function getReport() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'select',
                                    fields: ['informes.id', 'informes.icono', 'informes.url', 'informes.nombre', 'informes.descripcion', 'informes.visible', 'informes.width', 'informes.height'],
                                    where: ' informes.id = ' + _this4.id,
                                    table: 'informes'
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _this4.form = {
                                            icono: response.data.icono,
                                            url: response.data.url,
                                            nombre: response.data.nombre,
                                            descripcion: response.data.descripcion,
                                            user_id: response.data.user_id,
                                            height: response.data.height,
                                            width: response.data.width,
                                            visible: parseInt(response.data.visible)
                                        };
                                        _this4.old = {
                                            icono: response.data.icono,
                                            url: response.data.url,
                                            nombre: response.data.nombre,
                                            descripcion: response.data.descripcion,
                                            user_id: response.data.user_id,
                                            height: response.data.height,
                                            width: response.data.width,
                                            visible: parseInt(response.data.visible)
                                        };
                                        _this4.showIframe = true;
                                    }
                                    setTimeout(function () {
                                        _this4.loading = false;
                                    }, 100);
                                });

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        save: function save() {
            this.$root.$emit('isConnect');
            if (this.project.length == 0) {
                this.$root.$emit('msgError', 'El campo "Proyecto asociado" es obligatorio');
                this.error = true;
                return false;
            } else {
                this.error = false;
            }

            if (!this.form.nombre) {
                this.$root.$emit('msgError', 'El campo nombre es obligatorio');
                this.error = true;
                return false;
            } else {
                this.error = false;
            }
            if (!this.form.url) {
                this.$root.$emit('msgError', 'El campo url es obligatorio');
                this.error = true;
                return false;
            } else {
                this.error = false;
            }

            if (this.error == false) {
                this.id > 0 ? this.update() : this.insert();
            }
        },
        insert: function insert() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'INSERT',
                                    table: 'informes',
                                    form: {
                                        icono: _this5.form.icono,
                                        url: _this5.form.url,
                                        nombre: _this5.form.nombre,
                                        descripcion: _this5.form.descripcion,
                                        visible: _this5.form.visible
                                    }
                                }).then(function (response) {
                                    if (response.data != 'Algo ha fallado') {
                                        _api2.default.post("public/v1", {
                                            token: localStorage.getItem("analiticatoken"),
                                            single: true,
                                            method: 'INSERT',
                                            table: 'informe_usuario',
                                            form: {
                                                informe_id: parseInt(response.data),
                                                user_id: _this5.form.user_id
                                            }
                                        }).then(function (response) {
                                            if (response.data != 'Algo ha fallado') {
                                                _this5.id = parseInt(response.data);
                                                setTimeout(function () {
                                                    _this5.project.forEach(function (e) {
                                                        _this5.insertProject(e);
                                                    });
                                                }, 100);

                                                _this5.$root.$emit('msgSuccess', 'Registro insertado');
                                                setTimeout(function () {
                                                    _this5.$router.push('/dashboard/proyectos');
                                                }, 2000);
                                            } else {
                                                _this5.$root.$emit('msgError', 'Algo ha fallado');
                                            }
                                        });
                                    } else {
                                        _this5.$root.$emit('msgError', 'Algo ha fallado');
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        update: function update() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:

                                if (_this6.form.icono != _this6.old.icono) {
                                    _this6.error = true;
                                }
                                if (_this6.form.nombre != _this6.old.nombre) {
                                    _this6.error = true;
                                }
                                if (_this6.form.url != _this6.old.url) {
                                    _this6.error = true;
                                }
                                if (_this6.form.visible != _this6.old.visible) {
                                    _this6.error = true;
                                }
                                if (_this6.form.descripcion != _this6.old.descripcion) {
                                    _this6.error = true;
                                }
                                if (_this6.form.width != _this6.old.width) {
                                    _this6.error = true;
                                }
                                if (_this6.form.height != _this6.old.height) {
                                    _this6.error = true;
                                }
                                if (_this6.form.user_id != _this6.old.user_id && _this6.error == false) {
                                    // this.updatePivot()
                                } else if (_this6.error == true) {
                                    _api2.default.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: true,
                                        method: 'UPDATE',
                                        id: _this6.id,
                                        table: 'informes',
                                        form: {
                                            icono: _this6.form.icono,
                                            url: _this6.form.url,
                                            nombre: _this6.form.nombre,
                                            descripcion: _this6.form.descripcion,
                                            visible: _this6.form.visible,
                                            height: _this6.form.height,
                                            width: _this6.form.width
                                        }
                                    }).then(function (response) {
                                        if (response.data == 1) {
                                            _this6.$root.$emit('msgSuccess', 'Registro insertado');
                                            setTimeout(function () {
                                                _this6.$router.push('/dashboard/proyectos');
                                            }, 2000);
                                        } else {
                                            _this6.$root.$emit('msgError', 'Algo ha fallado');
                                        }
                                    });
                                }

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },
        addProject: function addProject() {
            this.addNewProject = true;
        },
        deleteProjectc: function deleteProjectc(e) {
            if (this.id) {
                this.borrado = e;
            }
        },
        changueProjectc: function changueProjectc(e) {
            var _this7 = this;

            this.$root.$emit('isConnect');
            setTimeout(function () {
                if (_this7.id) {
                    if (_this7.borrado == false) {
                        _this7.insertProject(parseInt(e[e.length - 1]));
                    } else {
                        _this7.proyectoOld.filter(function (p) {
                            if (_this7.borrado == p.project_id) {
                                _this7.updateProjectc(p.id);
                                _this7.borrado = false;
                            }
                        });
                    }
                }
            }, 500);
        },
        insertProject: function insertProject(p) {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'INSERT',
                                    table: 'reports_projects',
                                    form: {
                                        report_id: _this8.id,
                                        project_id: p
                                    }
                                }).then(function (response) {
                                    _this8.$root.$emit('msgSuccess', 'Registro actualizado con éxito');
                                });

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },
        updateProjectc: function updateProjectc(p) {
            var _this9 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _api2.default.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'DELETE',
                                    id: p,
                                    table: 'reports_projects'
                                }).then(function (response) {
                                    _this9.$root.$emit('msgSuccess', 'Registro actualizado con éxito');
                                });
                                _this9.borrado = false;

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9);
            }))();
        },
        setIframe: function setIframe() {
            if (this.form.url.length > 10) {
                this.showIframe = true;
            } else {
                this.showIframe = false;
            }
        },
        close: function close() {
            this.$root.$emit('isConnect');
            this.$router.replace('/dashboard/proyectos');
        }
    }
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.96efa205ea51ab819c7a.js